var NguCarouselStore = /** @class */ (function () {
    function NguCarouselStore() {
    }
    return NguCarouselStore;
}());
export { NguCarouselStore };
var ItemsControl = /** @class */ (function () {
    function ItemsControl() {
    }
    return ItemsControl;
}());
export { ItemsControl };
var Touch = /** @class */ (function () {
    function Touch() {
    }
    return Touch;
}());
export { Touch };
var Transfrom = /** @class */ (function () {
    function Transfrom() {
    }
    return Transfrom;
}());
export { Transfrom };
var NguCarousel = /** @class */ (function () {
    function NguCarousel() {
    }
    return NguCarousel;
}());
export { NguCarousel };
//# sourceMappingURL=ngu-carousel.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ngu/carousel/src/ngu-carousel/ngu-carousel.interface.js
// module id = ./node_modules/@ngu/carousel/src/ngu-carousel/ngu-carousel.interface.js
// module chunks = vendor